var _rect, _ellipse, _path, _path2, _ellipse2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoApproveOrReject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.644653,
    width: 80,
    height: 80.8223,
    rx: 40,
    fill: "#F7F9E6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.1667,
    cy: 23.8348,
    rx: 16.6667,
    ry: 16.838,
    fill: "#EB3342"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4998 29.5598L22.8332 18.11",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8332 29.5598L11.4998 18.11",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.8332,
    cy: 23.8348,
    rx: 16.6667,
    ry: 16.838,
    fill: "#289548"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9165 22.2053L61.6896 29.3072C61.6896 29.3072 66.8881 21.8688 71.3332 18.7834",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5003 66.2458L50.6047 73.4812L57.6126 58.8693L39.0003 52.4562L35.5003 66.2458Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3577 66.2459L36.0972 64.5678L33.9535 58.9186C33.262 57.0996 33.3141 55.0776 34.0982 53.2974L36.1999 48.5283C37.4252 45.748 40.6494 44.4976 43.4014 45.7355",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3577 66.2459L36.0972 64.5678L33.9535 58.9186C33.262 57.0996 33.3141 55.0776 34.0982 53.2974L36.1999 48.5283C37.4252 45.748 40.6494 44.4976 43.4014 45.7355",
    stroke: "#004752",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4436 52.4477L49.6876 31.4719C50.3002 30.0818 51.9124 29.4566 53.2884 30.0755C54.6644 30.6945 55.2832 32.3231 54.6706 33.7133L50.6032 42.9427L53.9252 44.4369C54.8425 44.8495 55.2551 45.9353 54.8467 46.8621L58.1686 48.3563C59.086 48.769 59.4985 49.8548 59.0901 50.7815L61.5816 51.9022C62.9576 52.5211 63.5764 54.1498 62.9638 55.54L60.6713 60.742C59.9835 62.3014 59.0843 63.7566 57.9996 65.0657L51.1373 73.3435",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4436 52.4477L49.6876 31.4719C50.3002 30.0818 51.9124 29.4566 53.2884 30.0755C54.6644 30.6945 55.2832 32.3231 54.6706 33.7133L50.6032 42.9427L53.9252 44.4369C54.8425 44.8495 55.2551 45.9353 54.8467 46.8621L58.1686 48.3563C59.086 48.769 59.4985 49.8548 59.0901 50.7815L61.5816 51.9022C62.9576 52.5211 63.5764 54.1498 62.9638 55.54L60.6713 60.742C59.9835 62.3014 59.0843 63.7566 57.9996 65.0657L51.1373 73.3435",
    stroke: "#004752",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8481 46.8588L53.369 50.2149L54.8481 46.8588Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8481 46.8588L53.369 50.2149",
    stroke: "#004752",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6044 42.9394L48.3859 47.9736L50.6044 42.9394Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6044 42.9394L48.3859 47.9736",
    stroke: "#004752",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0912 50.7782L57.6122 54.1344L59.0912 50.7782Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0912 50.7782L57.6122 54.1344",
    stroke: "#004752",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoApproveOrReject);
export default __webpack_public_path__ + "static/media/info-approve-or-reject.8a97b760edd93f6782a064ee7234848d.svg";
export { ForwardRef as ReactComponent };